import Link from "next/link";
import styles from './sales.module.css';

type Props = {
    title: string,
    content: string,
    greyContainer: boolean,
    img: string,
    link: string,
    id: string
}

const TextImageContainer = ({title, content, greyContainer, img, link, id}: Props) => (
    <div id={id}  className={greyContainer ? `${styles.greyContainer} ${styles.TextImageContainer}` : `${styles.TextImageContainer} ${styles.normalContainer}`} >
        <div className={styles.textImage}>
            <img loading="lazy" src={`/images/sales/${img}`} alt={title}/>
        </div>

        <div className={styles.textContent}>
            <h3>{title}</h3>
            <p>{content}</p>
            <Link prefetch={false} href={link}><button className={styles.contactButton}>Find out more</button></Link>
        </div>
    </div>
);

export default TextImageContainer;